import React from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import { useAuthStore } from '../store/authStore';
import { LogIn, UserPlus, LayoutDashboard, LogOut } from 'lucide-react';

export default function PublicLayout({ children }) {
  const { user, logout } = useAuthStore();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-ee-bg text-white">
      <header className="sticky top-0 z-40 backdrop-blur-lg bg-ee-bg/80 border-b border-ee-border">
        <div className="ee-container flex items-center justify-between h-16">
          <Brand />
          <nav className="hidden md:flex items-center gap-6 text-sm text-ee-text2">
            <a href="#pillars" className="hover:text-gold transition-colors">Philosophy</a>
            <a href="#about" className="hover:text-gold transition-colors">About</a>
            <a href="#ee" className="hover:text-gold transition-colors">EE</a>
            <a href="#pricing" className="hover:text-gold transition-colors">Get the Book</a>
          </nav>
          <div className="flex items-center gap-3">
            {user ? (
              <>
                <Link to="/dashboard" className="inline-flex items-center gap-2 text-sm text-ee-text2 hover:text-gold"><LayoutDashboard size={16} /> Dashboard</Link>
                <button onClick={() => { logout(); nav('/'); }} className="inline-flex items-center gap-2 text-sm text-ee-muted hover:text-red-400"><LogOut size={16} /></button>
              </>
            ) : (
              <>
                <Link to="/login" className="inline-flex items-center gap-2 text-sm text-ee-text2 hover:text-gold"><LogIn size={16} /> Login</Link>
                <Link to="/register" className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-md gold-grad text-black text-sm font-semibold"><UserPlus size={14} /> Sign Up</Link>
              </>
            )}
          </div>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
